import { useEffect } from 'react';
import InnerLayout from '../components/InnerLayout';

export default function LegalesGenerales() {
  useEffect(() => { document.title = 'Legales Generales — Sttora'; }, []);
  return (
    <InnerLayout titleFirst="Legales" titleAccent="Generales" subtitle="Información legal corporativa y aviso legal de Sttora." breadcrumb="Legales Generales">
      <div className="legal-updated">Última actualización: Enero 2026</div>
      <div className="legal-content">
        <p><strong>Sttora</strong> es una empresa legalmente constituida con operaciones en múltiples jurisdicciones. El uso de esta plataforma implica la aceptación de los presentes términos legales.</p>
        <h2>Identidad Corporativa</h2>
        <p>Razón social: Sttora S.A. de C.V. (o entidad equivalente según la jurisdicción). Domicilio legal: Av. Corporativa 1000, Piso 12, Ciudad de México, México. Correo de contacto legal: <a href="mailto:legal@sttora.com">legal@sttora.com</a></p>
        <h2>Propiedad Intelectual</h2>
        <p>Todos los contenidos de esta plataforma — incluyendo logotipos, marcas, textos, imágenes, diseños y sistemas gráficos — son propiedad exclusiva de Sttora o de sus licenciantes, y están protegidos por las leyes de propiedad intelectual aplicables. Queda prohibida su reproducción, distribución o modificación sin autorización expresa.</p>
        <h2>Limitación de Responsabilidad</h2>
        <p>Sttora no garantiza la disponibilidad ininterrumpida de sus servicios. En ningún caso será responsable por daños indirectos, incidentales o emergentes derivados del uso de la plataforma.</p>
        <h2>Legislación Aplicable</h2>
        <p>Estos términos legales se rigen por las leyes vigentes en el domicilio fiscal de Sttora. Para la resolución de controversias, las partes se someten a los tribunales competentes de dicha jurisdicción.</p>
        <h2>Contacto Legal</h2>
        <p>Para consultas legales o ejercicio de derechos: <a href="mailto:legal@sttora.com">legal@sttora.com</a></p>
      </div>
    </InnerLayout>
  );
}
